import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CountryModel } from '../_models/country-model';


@Injectable({ providedIn: 'root' })
export class UploadService {

  commonURL = 'api/v1/public/';

  constructor(private http: HttpClient) { }


  getCountriesList(): Observable<CountryModel[]> {
    return this.http.get<CountryModel[]>('http://restcountries.eu/rest/v2/all?fields=name');
  }


  submitGoodOfficesServicesForm(formdata: FormData): Observable<HttpEvent<{}>> {

    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'good-offices-services/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }

  submitExpeditedArbitrationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'expedited-arbitrations/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }

  submitArbitrationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'arbitrations/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    return this.http.request(req);
  }

  submitMediationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'mediations/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    return this.http.request(req);
  }

   submitExpertDeterminationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'expert-determination/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    return this.http.request(req);
  }

  submitUnilateralMediationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'unilateral-mediations/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }


   submitUnilateralExpertForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'unilateral-expert-determination/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }

  submitAdrYoungRegistrationForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + this.commonURL + 'adr-young-registration', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }

  submitOfficesMediationForm(formdata: FormData): Observable<HttpEvent<{}>> {

    const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/public/offices/mediation/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });

    return this.http.request(req);

  }

  submitNoticeForm(formdata: FormData): Observable<HttpEvent<{}>> {
    const req = new HttpRequest('POST', environment.apiUrl + 'api/v1/public/notice-unauthorized-use/submit-request', formdata, {
      reportProgress: true,
      responseType: 'text'
    });
    return this.http.request(req);
  }

}
